module.exports = __webpack_public_path__ + "img/img-free-03.png";